import { render, staticRenderFns } from "./PaxelRecycleWasteType.vue?vue&type=template&id=1b66fbab&"
import script from "./PaxelRecycleWasteType.vue?vue&type=script&lang=js&"
export * from "./PaxelRecycleWasteType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports